(function () {
  'use strict';

  /* @ngdoc object
   * @name vcMain
   * @description
   *
   */
  angular
    .module('vcMain', [
      'constants',
      'ngAria',
      'ngCookies',
      'ngResource',
      'ngMessages',
      'ngSanitize',
      'ngMap',
      'ui.router',
      'ui.bootstrap',
      'pascalprecht.translate',
      'angular-jwt',
      'auth',
      'dashboard',
      'parcels',
      'settings',
      'temporaryWorkers',
      'ngFileSaver',
      'rzModule',
      'orders',
      'fertilization',
      'plantProtection',
      'ui.validate',
      'dashboard',
      'uiSwitch',
      'comments',
      'ui.select',
      'angular.filter',
      'angularMoment',
      'timeTracking',
      'exports',
      'angulartics',
      'orderTypes',
      'poi',
      'angulartics.piwik',
    ]);
}());
